'use client'

import * as React from 'react'
import { Button } from '@repo/design-system-cf/components/button'
import { IconFeaturedSeasonalAndGifts } from '@repo/design-system-cf/components/icons'
import { useTranslations } from 'next-intl'
import {
  GetAFreeBundleModal,
  HAS_SEEN_COOKIE_NAME,
  HAS_SHARED_DG_COOKIE_NAME,
} from './get-a-free-bundle-modal'
import { useCookies } from 'react-cookie'

interface Props {
  productId: number
  shareUrl: string
}

export const GetAFreeBundleButton = ({ productId, shareUrl }: Props) => {
  const [cookies, setCookie] = useCookies([HAS_SHARED_DG_COOKIE_NAME, HAS_SEEN_COOKIE_NAME])

  const t = useTranslations('pages.daily-gifts.banner_modal')
  const [isOpen, setIsOpen] = React.useState(false)

  React.useEffect(() => {
    try {
      const hasShared = cookies[HAS_SHARED_DG_COOKIE_NAME] === true
      const hasSeen = cookies[HAS_SEEN_COOKIE_NAME] === true

      if (!hasShared && !hasSeen) {
        setIsOpen(true)

        setCookie(HAS_SEEN_COOKIE_NAME, 'true', {
          expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000), // 30 days
          path: '/',
        })
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }, [cookies, setCookie])

  return (
    <>
      <div className="mt-12 mx-auto flex justify-center items-center">
        <Button
          variant="secondary"
          iconLeft={<IconFeaturedSeasonalAndGifts />}
          onClick={() => setIsOpen(true)}
        >
          {t('get_a_free_bundle')}
        </Button>
      </div>
      {isOpen ? (
        <GetAFreeBundleModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          productId={productId}
          shareUrl={shareUrl}
        />
      ) : null}
    </>
  )
}
